export class StatsInfoPanel {
    dom;
    min = Infinity;
    max = 0;
    name;
    fg;
    bg;
    PR;
    WIDTH = 80;
    HEIGHT = 48;
    TEXT_X = 3;
    TEXT_Y = 2;
    GRAPH_X = 3;
    GRAPH_Y = 15;
    GRAPH_WIDTH = 74;
    GRAPH_HEIGHT = 30;
    canvas;
    context;
    constructor(name, fg, bg) {
        this.name = name;
        this.fg = fg;
        this.bg = bg;
        this.PR = Math.round(window.devicePixelRatio || 1);
        this.WIDTH *= this.PR;
        this.HEIGHT *= this.PR;
        this.TEXT_X *= this.PR;
        this.TEXT_Y *= this.PR;
        this.GRAPH_X *= this.PR;
        this.GRAPH_Y *= this.PR;
        this.GRAPH_WIDTH *= this.PR;
        this.GRAPH_HEIGHT *= this.PR;
        this.canvas = document.createElement('canvas');
        this.canvas.width = this.WIDTH;
        this.canvas.height = this.HEIGHT;
        this.canvas.setAttribute('style', 'width:80px;height:48px');
        this.context = this.canvas.getContext('2d');
        if (this.context !== null) {
            this.context.font = `bold ${9 * this.PR}px Helvetica,Arial,sans-serif`;
            this.context.textBaseline = 'top';
            this.context.fillStyle = bg;
            this.context.fillRect(0, 0, this.WIDTH, this.HEIGHT);
            this.context.fillStyle = fg;
            this.context.fillText(name, this.TEXT_X, this.TEXT_Y);
            this.context.fillRect(this.GRAPH_X, this.GRAPH_Y, this.GRAPH_WIDTH, this.GRAPH_HEIGHT);
            this.context.fillStyle = bg;
            this.context.globalAlpha = 0.9;
            this.context.fillRect(this.GRAPH_X, this.GRAPH_Y, this.GRAPH_WIDTH, this.GRAPH_HEIGHT);
        }
        this.dom = this.canvas;
    }
    update(value, maxValue) {
        this.min = Math.min(this.min, value);
        this.max = Math.max(this.max, value);
        if (this.context !== null) {
            this.context.fillStyle = this.bg;
            this.context.globalAlpha = 1;
            this.context.fillRect(0, 0, this.WIDTH, this.GRAPH_Y);
            this.context.fillStyle = this.fg;
            const minMaxText = `(${Math.round(this.min)}-${Math.round(this.max)})`;
            this.context.fillText(`${Math.round(value)} ${this.name} ${minMaxText}`, this.TEXT_X, this.TEXT_Y);
            this.context.drawImage(this.canvas, this.GRAPH_X + this.PR, this.GRAPH_Y, this.GRAPH_WIDTH - this.PR, this.GRAPH_HEIGHT, this.GRAPH_X, this.GRAPH_Y, this.GRAPH_WIDTH - this.PR, this.GRAPH_HEIGHT);
            this.context.fillRect(this.GRAPH_X + this.GRAPH_WIDTH - this.PR, this.GRAPH_Y, this.PR, this.GRAPH_HEIGHT);
            this.context.fillStyle = this.bg;
            this.context.globalAlpha = 0.9;
            this.context.fillRect(this.GRAPH_X + this.GRAPH_WIDTH - this.PR, this.GRAPH_Y, this.PR, Math.round((1 - (value / maxValue)) * this.GRAPH_HEIGHT));
        }
    }
}
//# sourceMappingURL=StatsInfoPanel.js.map